import { FC } from "react";
import { COMPONENT_IDS } from "../../helpers/constants/componentIds";
import { AccordionStatusType } from "../../hooks/useAccordion";
import { MuiBox } from "../box/MuiBox";
import { MuiButtonTertiary } from "../button/MuiButton";
import { ExpandCollapseButtonWrapper } from "./ExpandCollapseButton.style";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useSiteCore } from "../../hooks/useSiteCore";

interface ExpandCollapseButtonProps {
  accordionStatus: AccordionStatusType;
  handleExpandCollapseAllChange: () => void;
}

export const ExpandCollapseButton: FC<ExpandCollapseButtonProps> = ({
  accordionStatus,
  handleExpandCollapseAllChange,
}) => {
  const { commonLabels } = useSiteCore();

  const getRemoveIcon = () => {
    return <RemoveIcon color={"primary"} />;
  };

  const getAddIcon = () => {
    return <AddIcon color={"primary"} />;
  };

  return (
    <ExpandCollapseButtonWrapper>
      <MuiBox className="header-collapse">
        <MuiButtonTertiary
          id={COMPONENT_IDS.EXPAND_COLLAPSE_BUTTON}
          onClick={handleExpandCollapseAllChange}
        >
          {accordionStatus.all
            ? commonLabels.collapseAll
            : commonLabels.expandAll}
          {accordionStatus.all ? getRemoveIcon() : getAddIcon()}
        </MuiButtonTertiary>
      </MuiBox>
    </ExpandCollapseButtonWrapper>
  );
};
